export default __webpack_public_path__ + "static/nine-74471ce97a4a50ba1b855a72734a6a21.png";